import { useEffect } from 'react';
import type { AngleAffiche, Courage } from '@nextilt/commun';
import { useAuPouce } from './surface';
import { poserLAngle, poserLAppareil, poserLeCourage } from './contexteDesGestes';

/**
 * Les crochets qui posent le contexte des gestes (chantier journal-des-gestes, ticket 05) :
 * l'appareil (`App.tsx`), l'angle (la feuille, les pages Maintenant et Agenda), le courage
 * (Maintenant). La règle et l'envoi : `contexteDesGestes.ts`, `api/client.ts`.
 */

/**
 * L'appareil, d'après `useAuPouce`. Posé pendant le rendu, avant les écrans qu'il contient, pour
 * que leurs premières requêtes le portent déjà ; une écriture de module qui ne change rien à
 * l'écran, la même à chaque rendu.
 */
export function useAppareilDesGestes(): void {
  poserLAppareil(useAuPouce() ? 'telephone' : 'ordinateur');
}

/**
 * L'angle affiché, tant que cet écran est là. `null` : cet écran ne dit pas l'angle (Maintenant
 * dans l'angle d'une feuille : c'est la feuille qui le dit), rien n'est posé ni retiré.
 */
export function useAngleDesGestes(angle: AngleAffiche | null): void {
  useEffect(() => {
    if (angle === null) return;
    poserLAngle(angle);
    return () => poserLAngle(null);
  }, [angle]);
}

/** Le courage choisi dans Maintenant, tant que Maintenant est à l'écran. */
export function useCourageDesGestes(courage: Courage): void {
  useEffect(() => {
    poserLeCourage(courage);
    return () => poserLeCourage(null);
  }, [courage]);
}
